import { useTitle } from '../../common/hooks/useTitle.js';
import { BreadCrumbs } from '../BreadCrumbs/BreadCrumbs.js';
import type { BreadCrumbsProps } from '../BreadCrumbs/BreadCrumbs.js';

export const BreadCrumbsWithTitle = ({ breadCrumbPaths }: BreadCrumbsProps) => {
  useTitle(breadCrumbPaths.map(pair => pair.name));

  return <BreadCrumbs breadCrumbPaths={breadCrumbPaths} />;
};
